import styles from "./Industries.module.css";
import { industries } from "../../data/industries";

export function Industries() {
  return (
    <section id="industries" className={styles.section} aria-labelledby="industries-heading">
      <div className="container">
        <div className={styles.head}>
          <span className="eyebrow">Industries</span>
          <h2 id="industries-heading">Built for Businesses Across Industries.</h2>
        </div>

        <div className={styles.grid}>
          {industries.map((industry) => {
            const { Icon } = industry;
            return (
              <div key={industry.id} className={styles.card}>
                <Icon className={styles.icon} />
                <span>{industry.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
